<template>
  <div class="mod-rm__coursevehiclerela">

    <div style="margin-top: 5px;">
      <el-row :gutter="12">
        <!---------------- 左边 ----------------------->
        <!--查询人员-->
        <el-col :span="24">
          <el-card class="box-card">
            <el-row>
              <el-col>
<!--                <div ref="queryBox"-->
<!--                     class="queryBox"-->
<!--                     style="padding-right: 0px;padding-left: 0px;border-style: none;">-->

<!--                </div>-->
              </el-col>
            </el-row>

            <!-- 数据网格 -->
            <div class="dataBox">
                <el-col :span="24" style="margin-bottom:10px;"><span>成功{{successcount}}人，失败{{errorcount}}人</span></el-col>
                <el-col :span="24" style="margin-bottom:10px;"><span style="color: #ff1818">部分账户余额不足，请提醒部分经销商管理员及时预存资金。</span></el-col>
              <el-table border
                        ref="selectVehicleinfo"
                        :data="dataList"
                        v-loading="dataListLoading"
                        size="mini"
                        class="jySelectionAll"
                        stripe
                        style="width: 100%;"
                        @select="handleSelectionChange">
<!--                <el-table-column type="selection"-->
<!--                                 header-align="center"-->
<!--                                 align="center"-->
<!--                                 disabled="true"-->
<!--                                 :selectable='checkboxInit'-->
<!--                                 width="50">-->
<!--                </el-table-column>-->
                <!-- 用户ID -->
                <el-table-column prop="userCode"
                                 header-align="center"
                                 show-overflow-tooltip
                                 align="center"
                                 :label="$t('registe.blaanceuserid')">
                </el-table-column>
                <!--所属经销商 -->
                <el-table-column prop="distributor"
                                 header-align="center"
                                 show-overflow-tooltip
                                 align="center"
                                 :label="$t('registe.blaanceDealer')">
                </el-table-column>
                <!-- 所属母店(CKD)-->
                <el-table-column prop="ckdNumber"
                                 header-align="center"
                                 show-overflow-tooltip
                                 align="center"
                                 :label="$t('registe.blaanceMCKD')">
                  <template slot-scope="scope"> {{scope.row.ckdNumber}} </template>
                </el-table-column>
                  <!--组织类型 -->
                  <el-table-column prop="orgType"
                                   header-align="center"
                                   show-overflow-tooltip
                                   align="center"
                                   :label="$t('registe.orgType')">
                  </el-table-column>
                <!-- 排期价格 -->
                <el-table-column prop="price"
                                 header-align="center"
                                 align="center"
                                 show-overflow-tooltip
                                 :label="$t('registe.blaancePrice')">
                </el-table-column>
                <!-- 免除金额 -->
                <el-table-column prop="deratePrice"
                                 header-align="center"
                                 align="center"
                                 show-overflow-tooltip
                                 :label="$t('registe.blaanceexempt')">
                </el-table-column>
                <!-- 需支付金额 -->
                <el-table-column prop="payMoney"
                                 header-align="center"
                                 align="center"
                                 show-overflow-tooltip
                                 :label="$t('registe.blaancePay')">
                </el-table-column>
                <!-- 当前账户余额(扣除后)-->
                <el-table-column prop="balance"
                                 header-align="center"
                                 align="center"
                                 show-overflow-tooltip
                                 :label="$t('registe.blaanceaccount')">
                </el-table-column>
                <!-- 状态 -->
                <el-table-column prop="status"
                                 header-align="center"
                                 align="center"
                                 show-overflow-tooltip
                                 :formatter="demandformat"
                                 :show-overflow-tooltip="true"
                                 :label="$t('registe.blaanceState')">
                </el-table-column>
          </el-table>
            </div>
          </el-card>
        </el-col>

        <!---------------------- 右边 ----------------------------------->
      </el-row>
    </div>
  </div>
</template>
<script>
import mixinViewModule from '@/mixins/view-module'
import Vue from 'vue'
//import ClassTree from '@/components/rm/class-tree/index'
import showOffering from './offeringcommon/pcShowOfferingDetails/showok'
export default {
  props: {
    vehicleInfoList: {
      type: Array,
      required: false
    },
    isSelectElection: {
      type: Boolean,
      default: false
    },
    selectTable: {
      type: Array,
      required: false
    },
  },
  mixins: [mixinViewModule],
  data () {
    return {
      listDate:{},
      courseInfoList: [],
      mixinViewModuleOptions: {
        // getDataListURL: '/learning/offeringregiste/SeltctPersonnelList',
        getDataListURL: '/sys/courseinforela/queryuserdetails',
        // traineeRegisteCheck: '/learning/offeringregiste/TraineeRegisteCheck',
        traineeRegisteCheck: '/learning/offeringregiste/addRegisteCheck',
        getDataListIsPage: true,
        getfreerulescheckURL: '/learning/finance/queryDealerAccountAndFree'//'/learning/rule/freerules/check',//把维度减免接口  '/learning/finance/queryDealerAccountAndFree'
      },
      offeringConditionvalus:false,
      dataForm: {
        firstNameCn: '',
        lastNameCn: '',
        userNameCn: '',
        offeringId: '',
        email:'',
        idcard:'',
        userCode:''
      },
      reduction:0,// 减免人数
      reductiontotalmoney:0,//减免金额 为排期价格*减免人数
      isReductiontotalmoney:false,//是否显示减免
      paymenttotalmoney:0,//支付金额 培训总金额
      accountBalance: 0, //还剩账户余额
      accountBalances: 0, //还剩账户余额
      successcount: 0,
      errorcount: 0,
      dataForms: {
        priority: ''
      },
      parentData: [], // 接收父组件传过来的数据
      queryformLabelWidth: '184px',
      // 已选从没
      vehicleData: [],
      // 工位已选的车辆
      selectedVehicle: [],
      // 编辑面板标签对齐方式
      labelPosition: 'left',
      // 查询面板标签宽度
      queryLabelWidth: '85px',
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      priorityArr: this.enums['priority'], // 优先级
      dataListLoading: false,
      // subordinateSiteId: '',
      // subordinateSiteName: '',
      dataListSelections: [],
      peopleDataList: [],
      queryVehicleUrl: '/rm/vehicleclass/list',
      // 是否显示所属场地
      isShowSuboSite: false,
      subloading:false,
      isChecked: false,
      dataRule: {
        priority: [
          { required: true, message: this.$t('res.rela.priorityCheck'), trigger: 'blur' }
        ]
      }
    }
  },
  components: {
    showOffering
  },
  mounted () {
    // this.queryVehiclerela(() => {
    //   this.querSelect()
    // })
    // 延迟加载
    // _this.$nextTick(() => {
    //   _this.querSelect()
    // })
  },
  methods: {

      demandformat (row, column, cellValue) {
          if (cellValue === false) {
              return '失败'
          } else if (cellValue === true) {
              return '成功'
          }else {
              return ' '
          }
      },

    // 重置
    again (date) {
      this.showVehicleClassList = ''
        this.dataListLoading = true
        this.dataList = date
        this.dataListLoading = false
    //  this.getDataList()
    },

      handleSelectionChange1 (selection, row) {
          // 判断当前点击的是打钩还是取消打钩 true 则是打勾
          let isSelected = this.isExistRow(selection, row, 'userId')
          if (isSelected) {
              // 勾选
              if (this.vehicleData !== undefined) {
                  // 判断 vehicleData 是否有勾选的数据
                  if (!this.isExistRow(this.vehicleData, row, 'userId')) {
                      this.vehicleData.push(row)
                  }
              }
          } else {
              // 取消勾选
              for (let i in this.vehicleData) {
                  if (this.vehicleData[i].userId === row.userId) {
                      this.vehicleData.splice(i, 1)
                  }
              }
          }
      },



  }
}
</script>
<style>
/* 隐藏网格的全选按钮 */
.jySelectionAll
  > .el-table__fixed
  > .el-table__fixed-header-wrapper
  > .el-table__header
  > thead
  > tr
  > th
  > .cell
  > label {
  display: none;
}
/* 隐藏网格的全选按钮 */
.jySelectionAll
  > .el-table__header-wrapper
  > .el-table__header
  > thead
  > tr
  > th
  > .cell
  > label {
  display: none !important;
}
.timeRange1 .el-form-item__label {
  width: 40px !important;
  margin-left: 0px;
}
.timeRange2 .el-form-item__label {
  /* width: 60% !important; */
  margin-left: 0px;
}
.el-tag__close {
  margin: 8px auto 0;
  float: right;
}
.el-dialog__body {
    padding: 0px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
</style>
<style scoped>

.queryBox {
  /*border-color: #409EFF;*/
  border-color: #eeeeee;
  border-style: solid;
  border-width: 1px;
  padding-top: 10px;
  padding-left: 10px;
  padding-right: 41px;
  margin-bottom: 5px;
  margin-left: 3px;
  margin-right: 3px;
  font-size: 14px;
  background-color: #fff;
  border-radius: 4px;
}
</style>
